// extracted by mini-css-extract-plugin
export var chevronIcon = "_bm-2";
export var teamName = "_bm-1";
export var teamSwitcherButton = "_bm-0";